import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "16",
  viewBox: "0 0 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("filter", { id: "a" }, [
        _createElementVNode("feColorMatrix", {
          in: "SourceGraphic",
          values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        })
      ])
    ], -1),
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      filter: "url(#a)",
      transform: "translate(-2 -4)"
    }, [
      _createElementVNode("path", {
        fill: "#1A1A1A",
        d: "M4.372 7.24a.77.77 0 0 0-.253-.654l-1.866-2.25V4H8.05l4.482 9.83L16.473 4H22v.336l-1.597 1.53a.47.47 0 0 0-.177.449v11.248a.47.47 0 0 0 .177.448l1.56 1.53v.337h-7.844v-.336l1.616-1.569c.158-.158.158-.205.158-.447V8.434l-4.49 11.407h-.607L5.566 8.434v7.645c-.043.321.064.645.29.877l2.1 2.548v.337H2v-.337l2.1-2.548c.226-.233.326-.558.272-.877z"
      })
    ], -1)
  ]))]))
}
export default { render: render }